"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var CheckPartiallyViewport_1 = __importDefault(require("./CheckPartiallyViewport"));
var FadeInElements = /** @class */ (function (_super) {
    __extends(FadeInElements, _super);
    function FadeInElements() {
        var _this = _super.call(this) || this;
        var main = document.querySelector('main');
        _this.setElement(main);
        _this.fadeInElements = _this.getChildElements("[".concat(constants_1.DATA_FADE, "]"));
        // Fire functions
        _this.fadeIn();
        return _this;
    }
    FadeInElements.prototype.fadeIn = function () {
        var _this = this;
        var _a;
        // Add fadable class if items are NOT initially in viewport and window hasn't been scrolled down
        if (window.scrollY < 50) {
            (_a = this.fadeInElements) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
                if (!CheckPartiallyViewport_1.default.checkIfInViewportPartially(element)) {
                    element.classList.add(constantsClasses_1.CLASS_FADABLE);
                }
            });
        }
        // Only animate elements if window gets scrolled down, not up
        var oldScrollY = window.scrollY;
        window.addEventListener('scroll', function () {
            var _a;
            if (oldScrollY < window.scrollY) {
                (_a = _this.fadeInElements) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
                    if (CheckPartiallyViewport_1.default.checkIfInViewportPartially(element)) {
                        element.classList.add(constantsClasses_1.CLASS_FADE);
                    }
                });
            }
            else {
                return;
            }
            oldScrollY = window.scrollY;
        });
    };
    return FadeInElements;
}(AbstractComponent_1.default));
exports.default = FadeInElements;
